import React from 'react';

import { StyledTitle, StyledSubtitle, StyledText, StyledDiv } from './Common.screen.style';

export interface Props {
    title: string | undefined;
    subtitle: string | undefined | null;
    desc: string | JSX.Element | JSX.Element[] | null | undefined;
}

const commonScreen: React.FunctionComponent<Props> = ({ title, subtitle, desc }: Props) => {
  return (
    <StyledDiv>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubtitle>{subtitle}</StyledSubtitle>
      <StyledText>{desc}</StyledText>
    </StyledDiv>
  );
};

export default commonScreen;
